<template>
  <div>
    <div>
      <el-form
        status-icon
        :rules="rules"
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
      >
        <p class="subtitle">基本信息</p>
        <div class="clearfix">
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="机构名称:"
                prop="orgnName"
                required
              >
                <yh-select-tree
                  clearable
                  :width="250"
                  :load="listChildOrg"
                  :value="ruleForm.orgnName"
                  @change="handleTreeChange"
                  :render-content="renderOrgTreeItem"
                  accordion
                  lazy
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="人员姓名:"
                prop="userName"
              >
                <el-input
                  type="text"
                  v-model="ruleForm.userName"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="人员工号:"
                prop="workNo"
              >
                <el-input
                  type="text"
                  v-model="ruleForm.workNo"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="身份证号:"
                prop="idNo"
              >
                <el-input
                  type="text"
                  v-model="ruleForm.idNo"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="手机号:"
                prop="phone"
              >
                <el-input
                  type="text"
                  v-model="ruleForm.phone"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="职位:"
                prop="position"
              >
                <el-input
                  type="text"
                  v-model="ruleForm.position"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="性别:"
                prop="gender"
              >
                <el-select
                  v-model="ruleForm.gender"
                  placeholder="请选择性别"
                  clearable
                >
                  <el-option
                    v-for="item in genderSelect"
                    :key="item.dictValue"
                    :label="item.dictName"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="出生日期:"
                prop="birthday"
              >
                <el-date-picker
                  v-model="ruleForm.birthday"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择出生日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="邮箱地址:"
                prop="mail"
              >
                <el-input
                  type="text"
                  v-model="ruleForm.mail"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="教育背景:"
                prop="education"
              >
                <el-select
                  v-model="ruleForm.education"
                  placeholder="请选择学历"
                  clearable
                >
                  <el-option
                    v-for="item in educationSelect"
                    :key="item.dictValue"
                    :label="item.dictName"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="婚姻状态:"
                prop="maritalStatus"
              >
                <el-select
                  v-model="ruleForm.maritalStatus"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="item in maritalStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

          </el-row>
        </div>

        <p class="subtitle">系统信息</p>
        <div class="clearfix">
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="人员角色:"
                prop="roleId"
              >
                <el-select
                  v-model="ruleForm.roleId"
                  placeholder="请选择角色"
                  clearable
                >
                  <el-option
                    v-for="item in roleDropList"
                    :key="item.id"
                    :label="item.roleName"
                    :value="item.id"
                    :disabled="item.roleStatus == '0'"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="人员状态:"
                prop="status"
                required
              >
                <el-select
                  v-model="ruleForm.status"
                  placeholder="请选择状态"
                  clearable
                >
                  <el-option
                    v-for="item in statusDropList"
                    :key="item.dictValue"
                    :label="item.dictName"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
                <div
                  class="yh-tip"
                  v-show="ruleForm.status !== '0'"
                >人员{{statusText}}后将无法登录</div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="flex-center">
          <el-button @click="onCancelClick">取消</el-button>
          <el-button
            type="primary"
            @click="onSaveClick"
          >保存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { addNav, removeTab } from '@/mixins';
import mixin from './mixins';
import {
  validateWorkNo,
  validateIDNo,
  validatePhone,
  validateEmail,
  validateName,
  validateJobTitle,
} from '@/utils/validators';

export default {
  name: 'AddUser',
  mixins: [addNav, mixin, removeTab],
  data() {
    // 校验人员工号 是否重复
    const validateWorkNoAsync = (rule, value, callback) => {
      const params = {
        data: {
          id: '',
          workNo: value,
          phone: '',
          idNo: '',
        },
      };
      this.$_post(`${this.$API.userExistCheck}?v=1`, params).then((res) => {
        if (res.data.exsit === 1) {
          callback(new Error(this.$MSG.M0015));
        } else {
          callback();
        }
      });
    };
    // 校验身份证号是否重复
    const validateIDNoAsync = (rule, value, callback) => {
      const params = {
        data: {
          id: '',
          workNo: '',
          phone: '',
          idNo: value,
        },
      };
      this.$_post(`${this.$API.userExistCheck}?v=2`, params).then((res) => {
        if (res.data.exsit === 1) {
          callback(new Error(this.$MSG.M0016));
        } else {
          callback();
        }
      });
    };
    // 校验手机号是否重复
    const validatePhoneAsync = (rule, value, callback) => {
      const params = {
        data: {
          id: '',
          workNo: '',
          phone: value,
          idNo: '',
        },
      };
      this.$_post(`${this.$API.userExistCheck}?v=3`, params).then((res) => {
        if (res.data.exsit === 1) {
          callback(new Error(this.$MSG.M0017));
        } else {
          callback();
        }
      });
    };

    const sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      statusDropList: [],
      ruleForm: {
        maritalStatus: '',
        position: '',
        orgnName: sessionData.orgnName,
        workNo: '',
        roleName: '',
        roleId: '',
        orgnCode: sessionData.orgnCode,
        userName: '',
        idNo: '',
        gender: '',
        education: '',
        phone: '',
        birthday: '',
        status: '0',
        mail: '',
        workphone: '',
      },
      genderSelect: [],
      maritalStatusList: [
        {
          label: '未婚',
          value: '0',
        },
        {
          label: '已婚',
          value: '1',
        },
      ],
      educationSelect: [],
      statusSelect: [],
      radio: '',
      roleDropList: [],
      orgnTreeData: [],
      orgnNodeData: {},
      defaultProps: {
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf',
      },
      rules: {
        orgnName: [{ required: true, message: '请选择机构！' }],
        userName: [
          { required: true, message: this.$MSG.M0002, trigger: 'blur' },
          { validator: validateName },
        ],
        roleId: [
          { required: true, message: this.$MSG.M0012, trigger: 'change' },
        ],
        workNo: [
          { required: true, message: this.$MSG.M0001, trigger: 'blur' },
          { validator: validateWorkNo },
          { validator: validateWorkNoAsync, trigger: 'blur' },
        ],
        idNo: [
          { required: true, message: this.$MSG.M0008, trigger: 'blur' },
          { validator: validateIDNo },
          { validator: validateIDNoAsync, trigger: 'blur' },
        ],
        phone: [
          { required: true, message: this.$MSG.M0009, trigger: 'blur' },
          { validator: validatePhone },
          { validator: validatePhoneAsync, trigger: 'blur' },
        ],
        status: [
          { required: true, message: '请选择人员状态！', trigger: 'change' },
        ],
        mail: [{ validator: validateEmail }],
        position: [{ validator: validateJobTitle }],
      },
    };
  },
  computed: {
    statusText() {
      const statusMap = {
        0: '活跃',
        1: '冻结',
        2: '注销',
      };
      return statusMap[this.ruleForm.status];
    },
  },
  mounted() {
    this.listRole();
    this.getPeoStatus();
    this.getEducation();
    this.listGender();
  },
  methods: {
    handleTreeChange(data) {
      this.orgn = data;
      this.ruleForm.orgnName = this.orgn.name;
      this.ruleForm.orgnCode = this.orgn.orgnCode;
    },

    // 字典获取人员状态
    getPeoStatus() {
      const params = {
        data: {
          dictTypeCode: 'personStatus',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=1`, params).then((res) => {
        this.statusDropList = res.data.list;
      });
    },
    // 字典获取教育背景
    getEducation() {
      const params = {
        data: {
          dictTypeCode: 'userEducation',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=2`, params).then((res) => {
        this.educationSelect = res.data.list;
      });
    },
    // 性别
    listGender() {
      const params = {
        data: {
          dictTypeCode: 'gender',
        },
      };
      return this.$_post(`${this.$API.selectDict}?v=3`, params).then((res) => {
        this.genderSelect = res.data.list;
      });
    },
    // 给后端传新增数据
    postUser() {
      const { userId } = JSON.parse(sessionStorage.getItem('sessionData'));
      const params = {
        data: {
          ...this.ruleForm,
          roleCode: this.ruleForm.roleId,
          createUserid: userId,
        },
      };
      return this.$_post(this.$API.userAdd, params).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.$message.success(this.$MSG.M0019);
          this.handleTabsRemove('/addUser');
          this.addNav({
            name: '人员管理',
            path: '/userManagement',
          });
        } else {
          this.$message.error(this.$MSG.M0018);
          this.handleTabsRemove('/addUser');
        }
      });
    },
    // 保存
    onSaveClick() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$_yh_confirm('确定新增人员').then(() => {
            this.postUser();
          });
        }
      });
    },
    // 是否取消新增
    onCancelClick() {
      this.$_yh_confirm('确认取消，取消后信息将不保存').then(() => {
        this.handleTabsRemove('/addUser');
        this.addNav({
          name: '人员管理',
          path: '/userManagement',
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.subtitle {
  padding: 20px 0 0 1em;
  text-align: left;
  color: #409eff;
}
.el-select {
  display: block;
}
.yh-tip {
  text-align: left;
  line-height: 1.2;
  font-size: 12px;
  color: #999;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
